import { Component } from '@angular/core';

import { DoorBellProvider } from '../../providers/door-bell/door-bell';

@Component({
  selector: 'door-bell',
  templateUrl: 'door-bell.html'
})
export class DoorBellComponent {

  constructor(
    private doorBellProvider: DoorBellProvider,
  ) {
  }

  test() {
    this.doorBellProvider.activateDoorBell();
  }
}



// WEBPACK FOOTER //
// ./src/components/door-bell/door-bell.ts